// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Layout$PrezzeeRibbon from "../../../theme/Theme__Layout.bs.js";
import * as StatsTile__Background$PrezzeeRibbon from "./StatsTile__Background.bs.js";

var wrapper = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.borderRadius(Theme__Layout$PrezzeeRibbon.Personal.borderRadius),
      BsCssJs$PrezzeeRibbon.minHeight(BsCssJs$PrezzeeRibbon.px(158)),
      BsCssJs$PrezzeeRibbon.position("relative"),
      BsCssJs$PrezzeeRibbon.overflow("hidden"),
      BsCssJs$PrezzeeRibbon.boxSizing("borderBox"),
      BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.px(16))
    ]);

var contentWrapper = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.position("relative"),
      BsCssJs$PrezzeeRibbon.zIndex(1),
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.flexDirection("column"),
      BsCssJs$PrezzeeRibbon.justifyContent("center"),
      BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100)),
      BsCssJs$PrezzeeRibbon.children([
            BsCssJs$PrezzeeRibbon.display("flex"),
            BsCssJs$PrezzeeRibbon.justifyContent("center")
          ])
    ]);

var Styles = {
  wrapper: wrapper,
  contentWrapper: contentWrapper
};

function StatsTile(props) {
  var className = props.className;
  var backgroundImage = props.backgroundImage;
  var className$1 = className !== undefined ? className : "";
  var backgroundImageMain = Belt_Option.getWithDefault(backgroundImage, "");
  var backgroundImage$1 = backgroundImage !== undefined ? JsxRuntime.jsx(StatsTile__Background$PrezzeeRibbon.make, {
          backgroundImage: backgroundImageMain,
          backgroundImageMobile: props.backgroundImageMobile
        }) : null;
  return JsxRuntime.jsxs("div", {
              children: [
                backgroundImage$1,
                JsxRuntime.jsx("div", {
                      children: props.content,
                      className: contentWrapper
                    })
              ],
              className: Classnames([
                    wrapper,
                    className$1
                  ])
            });
}

var BackgroundImage;

var make = StatsTile;

export {
  BackgroundImage ,
  Styles ,
  make ,
}
/* wrapper Not a pure module */
